import classNames from 'classnames';
import React from 'react';
import { wrapField } from '../../hooks/useForm';
import { getIconBaseUrl } from '../../../utils/assets';
import styles from './checkboxInput.module.scss';
import ErrorLabel from '../ErrorLabel';
const htmlId = 'bl-haven-checkbox-';
/** A checkbox form input field */
const CheckboxInput = React.forwardRef(({ id, name, label, htmlLabel, helpText, value, onChange, onBlur, disabled, className, error, icon = getIconBaseUrl('check-white.svg'), reverse, labelOnRight = false, verticalAlignment = 'bottom', isPartialChecked = false, checkboxAlternative, disableHover = false, }, ref) => {
    const hasError = !!error;
    return (<>
        <label htmlFor={`${htmlId}${id}`} className={classNames(styles.checkboxContainer, className, {
            [styles.error]: hasError,
            [styles.disabled]: disabled,
            [styles.reverse]: reverse,
            [styles.rightLabel]: labelOnRight,
            [styles.disableHover]: disableHover,
            [styles.withCheckboxAlternative]: checkboxAlternative,
        })}>
          <input id={`${htmlId}${id}`} type='checkbox' name={name} checked={value} value={String(value)} disabled={disabled} onChange={(e) => {
            onChange(e.target.checked);
        }} onBlur={onBlur} ref={ref} data-testid={`${htmlId}${id}`}/>
          <span className={styles.label}>
            {htmlLabel || label}
            {helpText && <span className={styles.helpText}>{helpText}</span>}
          </span>
          {!checkboxAlternative ? (<span className={classNames(styles.checkmark, {
                [styles.checkmark_top]: verticalAlignment === 'top',
                [styles.checkmark_center]: verticalAlignment === 'center',
                [styles.checkmark_partialChecked]: isPartialChecked,
            })}>
              <img src={icon} alt='checked' width='16' height='16'/>
            </span>) : (checkboxAlternative(value, isPartialChecked))}
          {hasError && <ErrorLabel error={error}/>}
        </label>
      </>);
});
CheckboxInput.displayName = 'CheckboxInput';
export const CheckboxInputField = wrapField(CheckboxInput);
export default CheckboxInput;
